/**
 * Product Gallery Swiper with Variant-based Image Switching
 * Handles swiper initialization and variant-based image switching
 */

document.addEventListener("DOMContentLoaded", function () {
  let thumbsSwiper = null;
  let mainSwiper = null;
  function initializeSwipers() {
    const thumbsSwiperEl = document.querySelector('.product-thumbnails-swiper');
    const mainSwiperEl = document.querySelector('.product-main-swiper');
    if (!thumbsSwiperEl || !mainSwiperEl) return;
    thumbsSwiper = new Swiper(thumbsSwiperEl, {
      slidesPerView: 4.5,
      spaceBetween: 15,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      breakpoints: {
        0: {
          spaceBetween: 8,
        },
        640: {
          spaceBetween: 10,
        },
        1024: {
          spaceBetween: 15,
        },
      }
    });

    mainSwiper = new Swiper(mainSwiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
      navigation: {
        nextEl: '.product-swiper-next',
        prevEl: '.product-swiper-prev',
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
      on: {
        slideChange: function () {
          handleSlideChange(this);
        },
      },
    });
  }

  function handleSlideChange(swiper) {
    const previousIndex = swiper.previousIndex;
    const currentIndex = swiper.activeIndex;
    const slides = swiper.slides;

    if (previousIndex !== undefined && slides[previousIndex]) {
      const prevSlide = slides[previousIndex];
      const prevVideo = prevSlide.querySelector('video');
      if (prevVideo && !prevVideo.paused) {
        prevVideo.pause();
        prevVideo.currentTime = 0;
      }
    }

    const currentSlide = slides[currentIndex];
    const currentVideo = currentSlide.querySelector('video');
    if (currentVideo) {
      currentVideo.play().catch(() => {
        console.log('Autoplay prevented, user interaction required.');
      });
    }
  }


  function handleVariantChange(event) {
    const newVariant = event.detail.variant;    
    if (!newVariant || !mainSwiper) return;
    if (newVariant.featured_image) {
      const variantImageId = newVariant.featured_media.id;
      const slides = mainSwiper.slides;
      let targetSlideIndex = -1;
      for (let i = 0; i < slides.length; i++) {
        const slide = slides[i];
        const mediaId = slide.getAttribute('data-media-id');
        if (mediaId && parseInt(mediaId) === variantImageId) {
          targetSlideIndex = i;
          break;
        }
      }
      if (targetSlideIndex !== -1) {
        mainSwiper.slideTo(targetSlideIndex);
        console.log(`Switched to variant image slide ${targetSlideIndex}`);
      } else {
        console.log('Variant image not found in swiper slides');
      }
    } else {
      console.log('Variant has no featured image, skipping image switch');
    }
  }
  initializeSwipers();
  document.addEventListener('theme:variant:change', handleVariantChange);
  if (!thumbsSwiper || !mainSwiper) {
    setTimeout(initializeSwipers, 100);
  }
});